import request from '@/utils/request'

// 获取用户信息
export function getInfo() {
    return request({
        url: 'web/info',
        method: 'get'
    })
}

// 获取账号安全等级
export function getLevel()
{
    return request({
        url: 'web/getLevel',
        method: 'get'
    })
}

// 设置支付密码
export function saveTpwd(data)
{
    return request({
        url: 'web/saveTpwd',
        method: 'post',
        data
    })
}

// 更新密码
export function updatePassword(data) {
    return request({
        url: 'web/updatePassword',
        method: 'post',
        data
    })
}

// 更新交易密码
export function updateTpassword(data) {
    return request({
        url: 'web/updateTpassword',
        method: 'post',
        data
    })
}
// 身份认证
export function userIdCard(data)
{
    return request({
        url: 'web/userIdCard',
        method: 'post',
        data
    })
}

// 收款设置
export function updateInfo(data)
{
    return request({
        url: 'web/updateInfo',
        method: 'post',
        data
    })
}

export function getSetting()
{
    return request({
        url: 'web/getSetting',
        method: 'get'
    })
}

export function idcardinfo()
{
    return request({
        url: 'web/idcardinfo',
        method: 'get'
    })
}

export function getDealList(data)
{
    return request({
        url: 'web/getDealList',
        method: 'get',
        params: data
    })
}

// 身份认证 new
export function nameAuth(data)
{
    return request({
        url: 'web/setNameAuth',
        method: 'post',
        data
    })
}
//获取验信息
export function getNameAuthInfo(data)
{
    return request({
        url: 'web/getNameAuthInfo',
        method: 'get',
        data
    })
}
// 绑定邮箱
export function bindEmail(data)
{
    return request({
        url: 'web/bindemail',
        method: 'post',
        data
    })
}

// 绑定手机
export function bindPhone(data)
{
    return request({
        url: 'web/bindphone',
        method: 'post',
        data
    })
}


//获取收益和下级人数
export function getMyEarningsAndPromotion(data)
{
    return request({
        url: 'web/getMyEarningsAndPromotion',
        method: 'get',
        params: data
    })
}


//获取收益详情
export function getMyEarningsDetail(data)
{
    return request({
        url: 'web/getMyEarningsDetail',
        method: 'get',
        params: data
    })
}


//获取人数详情
export function getMyPromotion(data)
{
    return request({
        url: 'web/getMyPromotion',
        method: 'get',
        params: data
    })
}
//获取证件类型
export function getIdcardType(data)
{
    return request({
        url: 'web/getIdcardType',
        method: 'get',
        params: data
    })
}
//高级认证
export function editCenterLevel(data)
{
    return request({
        url: 'web/editCenterLevel',
        method: 'post',
        data: data
    })
}
//是否高级认证，实名认证，地址认证
export function has_renzheng(data)
{
    return request({
        url: 'web/has_renzheng',
        method: 'get',
        params: data
    })
}
// 设置密保问题
export function setSecQuestion(data)
{
    return request({
        url: 'web/setSecQuestion',
        method: 'get',
        params: data
    })
}
// 贷币信息
export function lendMy(data)
{
    return request({
        url: 'web/lendMy',
        method: 'get',
        params: data
    })
}
// 贷币周期
export function lendList(data)
{
    return request({
        url: 'web/lendList',
        method: 'get',
        params: data
    })
}
//贷币
export function lendBuy(data)
{
    return request({
        url: 'web/lendBuy',
        method: 'post',
        data
    })
}
// 贷币列表
export function lendMylist(data)
{
    return request({
        url: 'web/lendMylist',
        method: 'get',
        params: data
    })
}
// 还款
export function lendBack(data)
{
    return request({
        url: 'web/lendBack',
        method: 'get',
        params: data
    })
}
// 新币申购列表
export function getNewcoinsList(data)
{
    return request({
        url: 'web/getNewcoinsList',
        method: 'get',
        params: data
    })
}
// 新币申购列表
export function getIcon(data)
{
    return request({
        url: 'web/icon',
        method: 'get',
        params: data
    })
}
// 新币申购信息
export function getNewcoinsInfo(data)
{
    return request({
        url: 'web/getNewcoinsInfo',
        method: 'get',
        params: data
    })
}
//新币提交
export function buyNewcoins(data)
{
    return request({
        url: 'web/buyNewcoins',
        method: 'post',
        data
    })
}
// 新币申购记录列表
export function getMyNewcoins(data)
{
    return request({
        url: 'web/getMyNewcoins',
        method: 'get',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/user.js